export const STAT_EVENT = {
  // 顶部导航点击
  nav_click: { g: '', a: 'click', o: '0', ext: '', module: '' },
  // 页脚点击
  footer_click: { g: '', a: 'click', o: '0', ext: '' },
  // 首页
  index_show: { g: 'index', a: 'show', o: '0', ext: '' },
  // 首页
  brand_show: { g: 'brand_page', a: 'show', o: '0', ext: '' },
  // 首页banner视频播放按钮点击
  index_banner_video_click: {
    g: 'index',
    a: 'click',
    o: '0',
    module: 'index_banner_video_play',
    ext: ''
  },
  // 广告产品区域点击查看更多按钮
  index_product_more_click: {
    g: 'index',
    a: 'click',
    o: '0',
    module: 'index_product_more',
    ext: ''
  },
  // 达人区域点击查看更多按钮
  index_star_more_click: {
    g: 'index',
    a: 'click',
    o: '0',
    module: 'index_kol_more',
    ext: ''
  },
  // 创意灵感区域点击视频播放按钮
  index_originality_video_play_click: {
    g: 'index',
    a: 'click',
    o: '',
    module: 'index_originality_video_play',
    ext: ''
  },
  // 创意灵感区域点击视频卡片
  index_originality_video_card_click: {
    g: 'index',
    a: 'click',
    o: '',
    module: 'index_originality_video_card',
    ext: ''
  },
  // 	创意灵感区域点击博文卡片
  index_originality_blog_card_click: {
    g: 'index',
    a: 'click',
    o: '',
    module: 'index_originality_blog_card',
    ext: ''
  },
  // 创意灵感区域点击查看更多按钮
  index_originality_more_click: {
    g: 'index',
    a: 'click',
    o: '0',
    module: 'index_originality_more',
    ext: ''
  },
  // 合作案例区域点击案例卡片
  index_senior_click: {
    g: 'index',
    a: 'click',
    o: '',
    module: 'index_senior_card',
    ext: ''
  },
  // 合作案例区域点击案例卡片
  index_senior_more_click: {
    g: 'index',
    a: 'click',
    o: '0',
    module: 'index_senior_more',
    ext: ''
  },
  'help-agreement_show': {
    g: 'help-agreement',
    a: 'show',
    o: '0',
    module: '',
    ext: ''
  },
  'help-privacy_show': {
    g: 'help-privacy',
    a: 'show',
    o: '0',
    module: '',
    ext: ''
  }
}

export const API_PATH = {
  user: {
    // 用户信息
    info: '/User_User/info'
  },
  alkSenior: {
    // 案例推荐接口
    recomm: '/Openapi_Alk_Case/recomm'
  },
  alkOriginality: {
    // 创意参考
    listByIds: '/Openapi_Alk_Originality/listByIds'
  },
  Comm_Consult: {
    // 留资
    receive: '/Comm_Consult/receive'
  },
  agent_message: {
    // 代理商列表
    list: '/agent_message/list'
  }
}

const ALK_API =
  process.env.VUE_APP_ENV === 'release'
    ? 'https://api.hd.weibo.com/api'
    : 'http://test.api.hd.weibo.com/api'

// 第三方接口
export const THIRD_API = {
  simaStat: {
    link: 'https://beacon.sina.com.cn/mrt.gif',
    // 线下模拟sima统计 该地址不存在 仅仅是为了非线上环境开发方便
    mock: '/sima/mock',
    desc: 'sima日志统计平台接口'
  },
  // 分片视频播放地址
  video: {
    link: `${ALK_API}/video/get`
  },
  bmap: {
    link: 'https://api.map.baidu.com/api?v=2.0&ak=49d8c5443322a47c8e0e145e0f9d0247&s=1',
    desc: '百度地图调用地址，目前用于行业资讯-市场活动，根据经纬度显示百度地图'
  },
  alkArticleList: {
    link: `${ALK_API}/article/list`,
    desc: '案例库行业资讯列表接口'
  },
  alkArticleCategoryList: {
    link: `${ALK_API}/article/categoryList`,
    desc: '案例库行业资讯类型列表'
  },
  alkTopicList: {
    link: `${ALK_API}/topic/list`
  },
  alkTopicDetail: {
    link: `${ALK_API}/topic/detail`
  },
  alkSendCode: {
    link: `${ALK_API}/passport/sendmsg`
  },
  alkPassportSignup: {
    link: `${ALK_API}/passport/signup`
  },
  alkCommonSignup: {
    link: `${ALK_API}/common/signup`
  },
  alkArticleDetail: {
    link: `${ALK_API}/article/detail`
  },
  alkSeniorDetail: {
    link: `${ALK_API}/seniorcase/detail`
  },
  alkSeniorCollect: {
    link: `${ALK_API}/seniorcase/collect`
  },
  alkFileList: {
    link: `${ALK_API}/file/list`
  },
  alkSubmitConsult: {
    link: `${ALK_API}/common/submitConsult`
  },
  alkTopicRelated: {
    link: `${ALK_API}/topic/relatedTopic`
  }
}

const ABS_PREFIX = ALK_API
// 绝对路径：用于图片等请求
export const ABS_PATH = {
  qrcode: ABS_PREFIX + '/Qrcode/index',
  /**
   * 获取图形验证码
   * http://wiki.intra.sina.com.cn/pages/viewpage.action?pageId=184030702
   */
  captchaImg: ABS_PREFIX + '/validate/img',
  /**
   * 下载单个文件
   * http://wiki.intra.sina.com.cn/pages/viewpage.action?pageId=193235534
   */
  downloadFile: ABS_PREFIX + '/download/file',
  /**
   * 下载打包文件
   * http://wiki.intra.sina.com.cn/pages/viewpage.action?pageId=187965080
   */
  downloadPack: ABS_PREFIX + '/download/pack'
}

export const ALK_BLUEV = {
  link: 'https://weibo.com/u/5521023040'
}
